import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LastViewedArticlesState, lastViewedArticlesFeatureKey } from './last-viewed-articles.reducer';

export const selectLastViewedArticlesState =
  createFeatureSelector<LastViewedArticlesState>(lastViewedArticlesFeatureKey);

export const selectLastViewedArticles = createSelector(
  selectLastViewedArticlesState,
  (state) => state.lastViewedArticles,
);
